<!--
 * @Description: 
 * @Author: Ingyi
 * @Date: 2021-09-02 00:12:30
 * @LastEditors: Ingyi
 * @LastEditTime: 2021-09-28 01:48:32
-->
<template>
  <div class="SupplyDetail">

    <div class="supply-content">
      <div class="supply-content-left">
        <img
          v-if="data && data.agencyzLogo"
          :src="data.agencyzLogo"
        />
      </div>

      <div class="supply-content-right">
        <div class="title">{{ data && data.name }}</div>
        <div class="sub-title">
          <span>入驻时间：{{ data && data.createTime }}&nbsp;&nbsp;&nbsp;</span>
        </div>
        <div class="content-row">
          <div class="label">企业名称：</div>
          <div class="data">{{ data && data.name }}</div>
        </div>
        <div class="content-row">
          <div class="label">企业类型：</div>
          <div class="data">{{ data && data.type }}</div>
        </div>
          <div class="content-row">
          <div class="label">联&nbsp;&nbsp;系&nbsp;&nbsp;人：</div>
          <div class="data">&nbsp;{{ this.isxian ? data.concat : " 登录后获取" }}</div>
        </div>
        <div class="content-row">
          <div class="label">联系电话：</div>
          <div class="data">&nbsp;{{ this.isxian ? data.concatPhone : " 登录后获取" }}</div>
        </div>

        <a-button class="buy-btn" type="primary" @click="handleAdd">{{
          "商标注册"
        }}</a-button>
        <a-button class="buy-btn" type="primary" @click="handleAddTransfer">{{
          "商标转让"
        }}</a-button>
        <a-button class="buy-btn" type="primary" @click="handleAddDesign">{{
          "商标设计"
        }}</a-button>
      </div>
    </div>

    <div class="content-detail" style="display: flex; max-width: 1280px">
      <!--  -->

      <div style="width: 20%; border-right: 10px solid #fff">
        <p class="title_top">
          <span class="line"></span>
          <span class="step_title">推荐专家
            <a style="margin-right:5px;font-size:12px;" @click="$router.push('/sysExpert')">>>more</a>
          </span>
        </p>
        <div style="padding: 20px;justify-content: space-around">
          <a-card
            v-for="item in sysExpert"
            :key="item.id"
            hoverable
            style="width:220px;"
            @click="
            () => $router.push({ path: '/sysExpertView', query: { id: item.id } })
          "
          >
            <img
              slot="cover"
              alt="example"
              :src="item.photo"/>
            <a-card-meta :title="item.name">
              <template slot="description">
                {{ item.graduation }}-{{ item.technical }}-{{ item.position }}
              </template>
            </a-card-meta>
          </a-card>
        </div>
      </div>
      <div style="flex: 1">
        <p class="title_top">
          <span class="line"></span>
          <span class="step_title">服务信息</span>
        </p>
        <div v-html="data && data.enterpriseDesc" style="padding: 20px"></div>
      </div>
    </div>
    <div class="content-detail" style="max-width: 1280px">
      <p class="title_top">
        <span class="line"></span>
        <span class="step_title">咨询列表</span>
      </p>

        <a-button
        class="zixun-btn"
          type="primary"
          @click="
            () => {
              formZ = {};
              visibleZ = true;
            }
          "
        >
          发起咨询
        </a-button>

      <div class="result-list"     v-if="this.list">
        <div
                    class="result-item" style="text-align:left;"
          v-for="item in list"
          @click="
            () =>
              $router.push({
                path: '/consultingDetail',
                query: { id: item.id, title: item.content, user: item.name },
              })
          "
          :key="item.id"
        >
          <div class="result-info">
            <div class="result-info-title" :title="item.content">{{ subString(item.content) }}</div>
            <div class="result-info-content">
              <span style="color: #959292">{{ item.type }}</span>
            </div>
            <div class="result-info-link">发布人：{{ item.name }} ({{ item.type }})</div>
          </div>
          <div class="result-time">
            <span>发布时间:{{ item.createTime }}</span>
          </div>
        </div>
      </div>
    </div>

    <a-modal
      title="发起咨询"
      :visible="visibleZ"
      :maskClosable="false"
      @cancel="visibleZ = false"
    >
      <template slot="footer">
      <a-popconfirm title="请确认是否提交?" @confirm="() => handleOkZ()"  okText="确定" cancelText="取消">
           <a-button key="submit" >
          提交
        </a-button>
          </a-popconfirm>
      </template>
      <a-form-model v-model="formZ">
        <a-form-model-item label="咨询内容">
          <a-textarea v-model="formZ.content" maxLength="50" placeholder="请输入最多500个字咨询内容" style="width:500px;height:200px;"></a-textarea>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
<!-- @ok="handleOk" -->
    <a-modal
      title="商标注册"
      :visible="visible"
      :confirm-loading="confirmLoading"
      :maskClosable="false"
      
      @cancel="visible = false"
    >
    <template slot="footer">
      <a-popconfirm title="请确认是否提交?" @confirm="() => handleOk()"  okText="确定" cancelText="取消">
           <a-button key="submit" >
          提交
        </a-button>
          </a-popconfirm>
      </template>

      <a-form-model v-model="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
        <a-form-model-item label="商标名称">
          <a-input v-model="form.trademarkName"  placeholder="请输入商标名称" maxLength="50"/>
        </a-form-model-item>
        <a-form-model-item label="商标说明"  placeholder="请输入商标说明" maxLength="500">
          <a-textarea v-model="form.trademarkDesc" v-/>
        </a-form-model-item>
        <a-form-model-item label="代理委托书">
          <!-- <a-input v-model="form.attorneyPower" /> -->

          <a-upload
            :showUploadList="true"
            :locale="locale"
            name="file"
            action="/newapp/api/common/attachment/"
            @change="handleChangeA"
          >
            <a-button> <a-icon type="upload" /> 上传 </a-button>
          </a-upload>
  
          <a
            v-for="item in singlepage"
            :key="item.id"
            :href="item.enclosurePath"
            ><img src="../assets/img/moban.png" style="width:13px;height:13px;"/>代理委托书模板</a
          >

        </a-form-model-item>
        <a-form-model-item label="商标图样">
          <a-select v-model="form.pattern" :default-value="form.pattern">
            <a-select-option :value="0"> 黑白 </a-select-option>
            <a-select-option :value="1"> 着色 </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="商标分类">
          <a-select v-model="form.trademarkClassify" mode="multiple">
            <a-select-option v-for="item in type" :key="item.key" :value="item.key">
              {{ item.value }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <!-- <a-form-model-item label="代理机构">
          <a-select v-model="form.agencyzId">
            <a-select-option v-for="item in org" :key="item.key" :value="item.key">
              {{ item.value }}
            </a-select-option>
          </a-select>
        </a-form-model-item> -->
        <a-form-model-item label="图片">
          <a-upload
            :showUploadList="true"
            :locale="locale"
            name="file"
            action="/newapp/api/common/attachment/"
            @change="handleChange"
          >
            <a-button> <a-icon type="upload" /> 上传 </a-button>
          </a-upload>

          <viewer>
            <img
              :src="form.imgIdUrl"
              style="margin: 8px; cursor: pointer"
              width="100%"
              height="100"
            />
          </viewer>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <!-- 商标转让莫弹出框 -->
    <a-modal
      title="商标转让"
      :visible="visibleTransfer"
      :maskClosable="false"
      :confirm-loading="confirmLoading"
      @cancel="visibleTransfer = false"
    >
    <template slot="footer">
      <a-popconfirm title="请确认是否提交?" @confirm="() => handleOkTransfer()"  okText="确定" cancelText="取消">
           <a-button key="submit" >
          提交
        </a-button>
          </a-popconfirm>
      </template>
      <a-form-model
        v-model="formTransfer"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 12 }"
      >
        <a-form-model-item label="商标名称">
          <a-input v-model="formTransfer.trademarkName" maxLength="50"/>
        </a-form-model-item>
        <a-form-model-item label="品牌介绍">
          <a-textarea v-model="formTransfer.trademarkDesc" maxLength="500"/>
        </a-form-model-item>
        <a-form-model-item label="商标有效期">
          <a-date-picker
            :locale="locale"
            v-model="formTransfer.termOfValidity"
            valueFormat="YYYY-MM-DD"
          />
        </a-form-model-item>
        <a-form-model-item label="项目标签">
          <template v-for="tag in formTransfer.applyProject">
            <a-tooltip v-if="tag.length > 20" :key="tag" :title="tag">
              <a-tag :key="tag" :closable="true" @close="() => handleClose(tag)">
                {{ `${tag.slice(0, 20)}...` }}
              </a-tag>
            </a-tooltip>
            <a-tag v-else :key="tag" @close="() => handleClose(tag)">
              {{ tag }}
            </a-tag>
          </template>
          <a-input
            v-if="inputVisible"
            ref="input"
            type="text"
            size="small"
            :style="{ width: '78px' }"
            :value="inputValue"
            @change="handleInputChange"
            @blur="handleInputConfirm"
            @keyup.enter="handleInputConfirm"
          />
          <a-tag style="background: #fff; borderstyle: dashed" @click="showInput">
            <a-icon type="plus" /> 新标签
          </a-tag>
        </a-form-model-item>
        <a-form-model-item label="商标使用区域">
          <a-select v-model="formTransfer.region">
            <a-select-option :value="0"> 中国大陆 </a-select-option>
            <a-select-option :value="1"> 国外地区 </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="商标分类">
          <a-select v-model="formTransfer.trademarkClassify" mode="multiple">
            <a-select-option v-for="item in type" :key="item.key" :value="item.key">
              {{ item.value }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <!-- <a-form-model-item label="代理机构">
          <a-select v-model="formTransfer.agencyzId">
            <a-select-option v-for="item in org" :key="item.key" :value="item.key">
              {{ item.value }}
            </a-select-option>
          </a-select>
        </a-form-model-item> -->
        <a-form-model-item label="商标图片">
          <a-upload
            :showUploadList="false"
            :locale="locale"
            name="file"
            action="/newapp/api/common/attachment/"
            @change="handleChangeTransfer"
          >
            <a-button> <a-icon type="upload" /> 上传 </a-button>
          </a-upload>

          <viewer>
            <img
              :src="formTransfer.trademarkLogoUrl"
              style="margin: 8px; cursor: pointer"
              width="100%"
              height="100"
            />
          </viewer>
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!-- 商标设计弹窗 -->

    <a-modal
      title="商标设计"
      :visible="visibleDesign"
      :maskClosable="false"
      :confirm-loading="confirmLoading"
      @ok="handleOkDesign"
      @cancel="visibleDesign = false"
    >
   <template slot="footer">
      <a-popconfirm title="请确认是否提交?" @confirm="() => handleOkDesign()"  okText="确定" cancelText="取消">
           <a-button key="submit" >
          提交
        </a-button>
          </a-popconfirm>
      </template>
      <a-form-model
        v-model="formDesign"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 12 }"
      >
        <a-form-model-item label="商标名称">
          <a-input v-model="formDesign.trademarkName" maxLength="50"/>
        </a-form-model-item>
        <a-form-model-item label="品牌介绍">
          <a-textarea v-model="formDesign.trademarkDesc" maxLength="500"/>
        </a-form-model-item>
        <a-form-model-item label="设计建议">
          <a-textarea v-model="formDesign.designProposal" maxLength="500"/>
        </a-form-model-item>
        <a-form-model-item label="期望完成时间">
          <a-date-picker
            v-model="formDesign.completeTime"
            :locale="locale"
            valueFormat="YYYY-MM-DD"
            :format="['YYYY-MM-DD']"
          />
        </a-form-model-item>
        <a-form-model-item label="所属行业">
          <a-select v-model="formDesign.industry">
            <a-select-option v-for="item in industry" :key="item.key" :value="item.key">
              {{ item.value }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <!-- <a-form-model-item label="代理机构">
          <a-select v-model="formDesign.agencyzId">
            <a-select-option v-for="item in org" :key="item.key" :value="item.key">
              {{ item.value }}
            </a-select-option>
          </a-select>
        </a-form-model-item> -->
      </a-form-model>
    </a-modal>
  </div>
</template>
<script>
import qs from "qs";

import request from "../util/request";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
export default {
  
  name: "supplyDetail",
  data() {
    return {
      loading: false,
      isxian: false,
      locale,
      data: {},
      single: {},
      paraId: "",
      title: "",
      visible: false,
      visibleTransfer: false,
      visibleDesign: false,
      confirmLoading: false,
      form: {},
      formTransfer: {
        applyProject: [],
      },
      formDesign: {},
      typeDisabled:{},
      mode: "date",
      beConsulted: {},
      inputVisible: false,
      inputValue: "",
      type: [],
      org: [],
      industry: [],
      sysExpert: [],
      singlepage: [],
      list: [],
      visibleZ: false,
      formZ: {},
      isnullflat: false,
    };
  },
  props: ["userInfo"],
  mounted() {
    const userInfo = localStorage.getItem("userInfo");

    if (userInfo) {
      this.isxian = true;
    }
    this.form.pattern=0;
    let id = this.$route.query.id;
    this.beConsulted = id;
    this.paraId = id;
    console.log(id);
    this.quertDetail(id);
    this.queryDict();
    // this.queryOrg();
    this.queryInd();
    this.queryExpert();
    this.queryList();
    this.querySinglepage("DLWTS");
  },
  methods: {
    queryList() {
      request({
        url: "/api/client/common/consulting/list",
        method: "get",
        params: { page: 1, pageSize: 10 ,beConsulted:this.beConsulted},
      }).then((res) => {
        if (res.code == "200") {
          this.list = res.data.records;
        }
      });
    },

    querySinglepage(code) {
      let url = "/api/client/common/singlepage/";
      request({
        url: url + code,
        method: "get",
      }).then((res) => {
        if (res.code == "200") {
         this.single = res.data;
          // request({
          //   url: "/common/attachment/detail",
          //   method: "get",
          //   params: { ids: this.single.enclosurePath },
          // }).then((res) => {
          //   this.singlepage = res.data;
          // });
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    queryExpert() {
      request({
        url: "/api/client/common/sysExpert/list",
        params: {
          page: 1,
          pageSize: 3,
        },
      }).then((res) => {
        this.sysExpert = res.data.records;
      });
    },
    handleOkZ() {
      this.formZ.beConsulted = this.beConsulted;
     if(typeof this.formZ.content=="undefined" ||  this.formZ.content==null ||  this.formZ.content  ==""){
        this.$message.error("咨询内容不能为空");
      return false;
      }
      request({
        url: "/api/client/common/consulting/",
        method: "post",
        params: this.formZ,
      }).then((res) => {
        if (res.code == "200") {
          this.$message.success("提交成功，商家已收到您的咨询信息，请注意在个人中心追踪您的咨询信息");
          this.visibleZ = false;
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    handleOpenChange1(open) {
      if (open) {
        this.mode = "time";
      }
    },
    handlePanelChange1(value, mode) {
      this.mode = mode;
    },
          //截取字符串
    subString(data) {
      console.log("需要截取的数据"+data);
     if(typeof data=="undefined" ||  data==null ||  data  ==""){
       return data;
     }else{
      if (data.length > 100) {
        return data.substring(0, 100);
      }
      return data;
      }
    },
    queryInd() {
      request({
        url: "/api/client/common/select/dict/list",
        params: {
          key: "industry",
        },
      }).then((res) => {
        console.log("dict", res);
        this.industry = res.data;
      });
    },
    handleChangeTransfer(info) {
      if (info.file.status === "done") {
        console.log(info);
        if (info.file.response.code == "200") {
          this.formTransfer.trademarkLogo = info.file.response.data.url;
          this.formTransfer.trademarkLogoUrl = info.file.response.data.url;
          this.$message.success(`${info.file.name} 上传成功`);
        } else {
          this.$message.error(info.file.response.msg);
        }
      } else if (info.file.status === "error") {
        this.$message.error(`${info.file.name} 文件上传失败`);
      }
    },
    orderAdd(pram, ty) {
      if (pram == 0) {
        request({
          url: "/api/client/common/order",
          method: "post",
          data: qs.stringify({ id: this.paraId, type: ty }),
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }).then((res) => {
          if (res.code == "200") {
            this.$message.success("下单成功");
          } else {
            this.$message.warning(res.msg);
          }
        });
      } else {
        this.$message.warning("已经卖出");
      }
    },
    quertDetail(id) {
      request({
        url: "/api/client/common/enterprise/" + id,
        method: "get",
      }).then((res) => {
        this.data = res.data;
      });
    },
    queryDict() {
      request({
        url: "/api/client/common/select/dict/list",
        params: {
          key: "trademarkclassify",
        },
      }).then((res) => {
        this.type = res.data;
      });
    },
    queryOrg() {
      request({
        url: "/api/tool/select/enterprise/list",
        params: {
          key: "ORG_OWNER",
        },
      }).then((res) => {
        this.org = res.data;
      });
    },
    handleChange(info) {
      if (info.file.status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === "done") {
        console.log(info);
        this.form.imgId = info.file.response.data.url;
        this.form.imgIdUrl = info.file.response.data.url;
        console.log(this.form.fileId);
        this.$message.success(`${info.file.name}文件上传成功`);
      } else if (info.file.status === "error") {
        this.$message.error(`${info.file.name} 文件上传失败`);
      }
    },
    handleChangeA(info) {
      if (info.file.status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === "done") {
        console.log(info);
        this.form.attorneyPower = info.file.response.data.url;
        this.form.attorneyPowerUrl = info.file.response.data.url;
        this.$message.success(`${info.file.name} 文件上传成功`);
      } else if (info.file.status === "error") {
        this.$message.error(`${info.file.name} 文件上传失败`);
      }
    },

    handleAdd() {
      let token = localStorage.getItem("token");
      console.log(token);
      if (token == null) {
        this.$router.push({ path: "/login", query: { url: location.hash } });
      }
      this.title = "新增";
      this.form = {};
      this.visible = true;
    },
    handleAddTransfer() {
      let token = localStorage.getItem("token");
      console.log(token);
      if (token == null) {
        this.$router.push({ path: "/login", query: { url: location.hash } });
      }
      this.formTransfer = { applyProject: [] };
      this.visibleTransfer = true;
    },
    handleAddDesign() {
      let token = localStorage.getItem("token");
      console.log(token);
      if (token == null) {
        this.$router.push({ path: "/login", query: { url: location.hash } });
      }
      this.formDesign = {};
      this.visibleDesign = true;
    },
    handleOkTransfer() {
      const params = Object.assign({}, this.formTransfer);
      params.agencyzId = this.paraId;
      if (typeof params.trademarkClassify == "object")
        params.trademarkClassify = params.trademarkClassify.join(",");
      if (typeof params.applyProject == "object")
        params.applyProject = params.applyProject.join(",");
           if (typeof params.trademarkClassify == "object") {
        params.trademarkClassify = params.trademarkClassify.join(",");
      }
       if(typeof params.trademarkName=="undefined" ||  params.trademarkName==null ||  params.trademarkName==""){
         this.$message.error("商标名称不能为空");
        return false;
      }
      if(typeof params.trademarkDesc=="undefined" ||  params.trademarkDesc==null ||  params.trademarkDesc==""){
        this.$message.error("商标说明不能为空");
        return false;
      }
      if(typeof params.termOfValidity=="undefined" ||  params.termOfValidity==null ||  params.termOfValidity==""){
        this.$message.error("请选择一个时间");
        return false;
      }
      if(typeof params.applyProject=="undefined" ||  params.applyProject==null ||  params.applyProject==""){
         this.$message.error("标签不能为空");
        return false;
      }
       
      if(typeof params.region=="undefined" ||  params.region==null ||  params.region===""){
        this.$message.error("请选择一个区域");
        return false;
      }
      if(typeof params.trademarkClassify=="undefined" ||  params.trademarkClassify==null ||  params.trademarkClassify==""){
        this.$message.error("请选择一个商标分类");
        return false;
      }
      if(typeof params.trademarkLogo=="undefined" ||  params.trademarkLogo==null ||  params.trademarkLogo==""){
          this.$message.error("请上传商标图片");
          return false;
      }
      request({
        url: "/api/client/common/trademark/trademarkassignment",
        method: "post",
        params,
      }).then((res) => {
        if (res.code == "200") {
          this.$message.info("下单成功，工作人员将在一到三个工作日内联系您，您可以再个人中心追踪您的订单状态。");
          this.visibleTransfer = false;
          this.formTransfer = {
            applyProject: [],
          };
          this.queryList();
        } else {
          this.$message.warning(res.msg);
        }
      });
    },

    handleOkDesign() {
      const params = Object.assign({}, this.formDesign);
      params.agencyzId = this.paraId;
        if(typeof params.trademarkName=="undefined" ||  params.trademarkName==null ||  params.trademarkName==""){
           this.$message.error("商标名称不能为空");
        return false;
      }
      if(typeof params.trademarkDesc=="undefined" ||  params.trademarkDesc==null ||  params.trademarkDesc==""){
         this.$message.error("品牌介绍不能为空");
        return false;
      }
      if(typeof params.designProposal=="undefined" ||  params.designProposal==null ||  params.designProposal==""){
         this.$message.error("设计建议不能为空");
        return false;
      }
      if(typeof params.completeTime=="undefined" ||  params.completeTime==null ||  params.completeTime==""){
         this.$message.error("请选择一个时间");
        return false;
      }
       
      if(typeof params.industry=="undefined" ||  params.industry==null ||  params.industry==""){
         this.$message.error("请选择一个行业");
        return false;
      }
    
      request({
        url: "/api/client/common/trademark/trademarkdesign",
        method: "post",
        params,
      }).then((res) => {
        if (res.code == "200") {
          this.$message.info("下单成功，工作人员将在一到三个工作日内联系您，您可以再个人中心追踪您的订单状态。");
          this.visibleDesign = false;
          this.formDesign = {};
          this.queryList();
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    handleOk() { 
      const params = Object.assign({}, this.form);
      params.agencyzId = this.paraId;
      if (typeof params.trademarkClassify == "object") {
        params.trademarkClassify = params.trademarkClassify.join(",");
      }
       if(typeof params.trademarkName=="undefined" ||  params.trademarkName==null ||  params.trademarkName==""){
         this.$message.error("商标名称不能为空");
          return false;
      }
      if(typeof params.trademarkDesc=="undefined" ||  params.trademarkDesc==null ||  params.trademarkDesc==""){
        this.$message.error("商标说明不能为空");
        return false;
      }else{
        if(params.trademarkDesc.length>500){
            this.$message.error("商标说明最多500字符");
        return false;
        }
      }
      if(typeof params.pattern=="undefined" ||  params.pattern==null ||  params.pattern===""){
        this.$message.error("请选择一个商标图样");
        return false;
      }
      if(typeof params.trademarkClassify=="undefined" ||  params.trademarkClassify==null ||  params.trademarkClassify==""){
        this.$message.error("商标分类不能为空");
        return false;
      }
       
      if(typeof params.attorneyPower=="undefined" ||  params.attorneyPower==null ||  params.attorneyPower==""){
        this.$message.error("请上传代理委托书");
        return false;
      }
      if(typeof params.imgId=="undefined" ||  params.imgId==null ||  params.imgId==""){
           this.$message.error("请上传logo图片");
        return false;
      }
      
      request({
          url: "/api/client/common/trademark/trademarkregister",
          method: "post",
          params,
        }).then((res) => {
          if (res.code == "200") {
            this.$message.info("下单成功，工作人员将在一到三个工作日内联系您，您可以再个人中心追踪您的订单状态。");
            this.visible = false;
            this.form = {};
            this.queryList();
          } else {
            this.$message.warning(res.msg);
          }
      });
    },
   isNUll(obj,param) {
      if(typeof obj=="undefined" || obj==null || obj==""){
        alert(param);
        return false;
      }else{
        return true;
      }
    },

    handleClose(removedTag) {
      let tags = this.formTransfer.applyProject;
      tags = tags.filter((tag) => tag !== removedTag);
      this.formTransfer.applyProject = tags;
    },

    showInput() {
      this.inputVisible = true;
      this.$nextTick(function () {
        this.$refs.input.focus();
      });
    },
    handleInputChange(e) {
      this.inputValue = e.target.value;
    },

    handleInputConfirm() {
      const inputValue = this.inputValue;
      let tags = this.formTransfer.applyProject;
      if (inputValue && tags.indexOf(inputValue) === -1) {
        tags = [...tags, inputValue];
      }
      console.log(tags);
      this.$set(this.formTransfer, "applyProject", tags);
      Object.assign(this, {
        inputVisible: false,
        inputValue: "",
      });
    },
  },
};
</script>
<style lang="less" scoped>
.supply-content {
  width: 1280px;
  background: #fff;
  margin: 20px auto;
  display: flex;
  .supply-content-left {
    width: 390px;
    img {
      margin: 20px;
      width: 350px;
      height: 350px;
      object-fit: contain;
    }
  }
  .supply-content-right {
    padding: 20px 0;
    flex: 1;
    .title {
      height: 60px;
      line-height: 30px;
      vertical-align: middle;
      font-size: 20px;
        color: #222;
      font-weight: 700;
    }
    .sub-title {
      text-align: left;
      vertical-align: middle;
      height: 40px;
      line-height: 40px;
      font-size: 14px;
    }
    .content-row {
      display: flex;
      align-items: center;
      height: 40px;
    }
    .buy-btn {
      margin: 40px;
      font-size: 16px;
    }
  }
}
.content-detail {
  background: #fff;
  margin: 0 auto;
   .zixun-btn{
    margin-left:40px;
  }
  .title_top {
    width: 100%;
    height: 34px;
    text-align: left;
    background: #e9f0f8;
    .line {
      height: 16px;
      line-height: 34px;
      display: inline-block;
      vertical-align: middle;
      margin-left: 15px;
      border-left: 4px solid #4790ff;
    }
    .step_title {
      font-size: 18px;
      font-weight: 700;
      text-align: left;
      line-height: 34px;
      margin-left: 10px;
      display: inline-block;
      vertical-align: middle;
    }
  }
  .row {
    display: flex;
    ul > li {
      line-height: 40px;
      font-size: 15px;
    }
    div {
      flex: 1;
    }
  }
}
ul {
  list-style: none;
}

.result-list {
  background: #fff;
  .result-item { padding:20px;
    align-items: center;
    display: flex;
    height: 200px;
    border-bottom: 2px solid #f2f2f2;
    .avatar {
      width: 220px;
      height: 140px;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .result-info {
      margin-left: 20px;
      width: 1000px;
      height: 140px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      .result-info-title {
        color: #959292;
        font-size: 18px;
        font-weight: bold;
      }
      .result-info-link {
        color: #140a0aa9;
      }
    }
    .result-time {
      color: #999;
    }
  }
}
</style>
